import type {Component, Editor} from 'grapesjs';
import type {EmailMakerCanvasDevice} from '@EmailMakerReact/email-maker-react.types';
import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';
import {refreshEditor, scrollToComponent} from '@EmailMakerReact/lib/email-maker-selection-library';
import {fixComponentLoadingOverlaysOnWindowResize} from '@EmailMakerReact/lib/email-maker-overlay-library';

const DEVICE_SWITCH_SCROLL_DELAY_MS = 300;
const DEVICE_SWITCH_REFRESH_DELAY_MS = 10;
const DEVICE_SWITCH_OVERLAY_FIX_DELAY_MS = 400;

export function selectComponent(editor: Editor, component: Component | null): void {
  editor.select(component ?? undefined);
}

export function undo(editor: Editor): void {
  editor.UndoManager.undo();
}

export function redo(editor: Editor): void {
  editor.UndoManager.redo();
}

export function canUndo(editor: Editor): boolean {
  return editor.UndoManager.hasUndo();
}

export function canRedo(editor: Editor): boolean {
  return editor.UndoManager.hasRedo();
}

/** Selects the canvas device, scrolling back to the selection, refreshing canvas offsets, and resizing loading overlays. */
export function setCanvasDevice(editor: Editor, device: EmailMakerCanvasDevice): void {
  const selected = editor.getSelected();
  const isEmailContainerSelected = selected?.is(EMAIL_MAKER_COMPONENT_TYPES.container.PMW_WRAPPER) ?? false;

  editor.setDevice(device);

  if (selected && !isEmailContainerSelected) {
    scrollToComponent(editor, {delay: DEVICE_SWITCH_SCROLL_DELAY_MS});
  }

  refreshEditor(editor, DEVICE_SWITCH_REFRESH_DELAY_MS);

  setTimeout(() => {
    // Bail if the editor was destroyed before this delayed resize fires, rather than touch a dead canvas.
    if (editor.getModel().destroyed) {
      return;
    }
    fixComponentLoadingOverlaysOnWindowResize(editor);
  }, DEVICE_SWITCH_OVERLAY_FIX_DELAY_MS);
}
